import { createAction } from "@reduxjs/toolkit";

export const changeAttendees = createAction<number[]>("changeAttendees");

export const removeAllAttendees = createAction("removeAllAttendees");
